export default __webpack_public_path__ + "static/media/i-password.32016030.png";